module.exports = __webpack_public_path__ + "img/user_bg.2f8df2fb.png";